module.exports = __webpack_public_path__ + "img/close-menu.6fb37441.png";